export const LOCAL_STORAGE_KEYS = {
  APP_STORAGE: 'app-storage',
  TOKEN: 'token'
}

export const SMARTY_API_SERVICE_NAME = 'smarty-address-api'
